import CallCardPage from 'components/calls/CallCardPage';
import {Route} from 'react-router';
import React from 'react';
import {inboxRoute} from 'components/routes/InboxRoute';
import {adminRoute} from './AdminRoute';
import {libraryRoute} from './LibraryRoute';
import {repProfileRoutes} from 'components/RepProfileRoutes';
import {callsRoute} from 'components/routes/CallsRoute';
import {EmbedParent} from 'components/EmbedParent';
import {dashV2Route} from './DashboardRoutes';
import {homepageRoutes} from 'components/routes/HomepageRoutes';

export const embedRoutes = (
  <Route path="/embed" component={EmbedParent}>
    {homepageRoutes}
    {libraryRoute}
    {dashV2Route}
    {inboxRoute}
    {adminRoute}
    {repProfileRoutes}
    {callsRoute}
    <Route path="call/:callId" component={CallCardPage} />
  </Route>
);
